import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { PostsDataService, PostsColumnsService } from '../../../services';
import { Post, PostsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-post-details',
  templateUrl: './post-details.component.html',
  styleUrls: ['./post-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PostDetailsComponent implements OnInit, OnDestroy {

  public post: Post = {};
  public posts: Post[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private postsDataService: PostsDataService,
    private postsColumnsService: PostsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Post - Details');
        this.getPost(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.post !== 'undefined') {
      this.post = this.dynamicDialogConfig.data.post;
    }
    this.columns = this.postsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getPost(id: number): void {
    this.isLoading = true;
    this.postsDataService.getPost(id).subscribe((response: Post|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.post = response;
      }
    });
  }

  list() {
    this.router.navigate(['/posts']);
  }

  add() {
    this.router.navigate(['/posts/add']);
  }

  edit() {
    this.router.navigate(['/posts/edit/' + this.post.id]);
  }

}
@Component({
  selector: 'app-post-details',
  templateUrl: './post-details.component.html',
  styleUrls: ['./post-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPostDetailsComponent extends PostDetailsComponent {
}

